/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import Popover from "@material-ui/core/Popover";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";

import Filter from "Assets/Svg/filter";
import ArrowDownIcon from "Assets/Svg/arrowdown";
import { ReactComponent as CloseIcon } from "Assets/Svg/closeMedium.svg";
import { useStyles } from "./FilterStyles";

const ROLE_OPTIONS = [
  "Cinematographer",
  "Candid Photographer",
  "Videographer",
  "Traditional Photographer",
  "Aerial Cinematographer / Drone Pilot",
  "Video Editor",
  "Photo Editor & Album Designer",
  "Reel Creator",
  "Assistant",
  "Studio Owner",
  "Event Company",
  "Company Owner",
];
const SIGNUP_TYPE_OPTIONS = ["email", "mobile", "google", "apple", "facebook"];
const CATEGORY_OPTIONS = ["single", "multiple"];

export default function SimplePopover({
  setFilter,
  setActionPerformed,
  setCategoryFilter,
  userFilter,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [finalAppliedAdminFilters, setFinalAppliedAdminFilters] = useState({});
  const [userFilters, setUserFilters] = useState({
    createdAtFrom: null,
    createdAtTo: null,
    role: "",
    category: "",
    isBlocked: "",
    isEmailVerified: "",
    isProfileCompleted: "",
    signUpType: "",
  });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const resetFilter = () => {
    setFilter(false);
    setCategoryFilter();
    setUserFilters({
      createdAtFrom: null,
      createdAtTo: null,
      role: "",
      category: "",
      isBlocked: "",
      isEmailVerified: "",
      isProfileCompleted: "",
      signUpType: "",
    });
    setFinalAppliedAdminFilters({});
    handleClose();
  };

  useEffect(() => {
    if (!userFilter) {
      resetFilter();
    }
  }, [userFilter]);

  const updateFilter = (key, value) => {
    const updated = { ...finalAppliedAdminFilters };
    if (value === "" || value === null) {
      delete updated[key];
    } else {
      updated[key] = value;
    }
    setFinalAppliedAdminFilters(updated);
  };

  const filterUsers = () => {
    try {
      setFilter(true);
      setCategoryFilter(finalAppliedAdminFilters);
      setActionPerformed(true);
      handleClose();
    } catch (error) {
      console.error("Error applying filters:", error);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        startIcon={<Filter />}
        endIcon={<ArrowDownIcon />}
        className={classes.filterButton}
      >
        <Typography className={classes.filterText}>Filter</Typography>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{ paper: classes.popUp3 }}
        marginThreshold={20}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box className={`${classes.popUp2}`}>
          <div className={classes.topBar}>
            <span
              role="button"
              tabIndex={0}
              onKeyDown={handleClose}
              onClick={handleClose}
              className={`${classes.onHover} ${classes.closeBtn}`}
            >
              <CloseIcon />
            </span>
          </div>

          {/* Date Range */}
          <Grid container className="date-pick1" style={{ marginBottom: 8 }}>
            <Grid item>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  label="From"
                  clearable
                  format="dd/MM/yyyy"
                  disableFuture
                  style={{ background: "rgba(0,0,0,0.02)", border: "1px solid #CCC", borderRadius: 4, marginLeft: 8, width: "45%" }}
                  value={userFilters.createdAtFrom}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, createdAtFrom: e });
                    updateFilter("createdAtFrom", e);
                  }}
                  views={["year", "month", "date"]}
                />
                <DatePicker
                  autoOk
                  label="To"
                  clearable
                  format="dd/MM/yyyy"
                  disableFuture
                  style={{ background: "rgba(0,0,0,0.02)", border: "1px solid #CCC", borderRadius: 4, marginLeft: 8, width: "45%" }}
                  minDate={userFilters.createdAtFrom || undefined}
                  value={userFilters.createdAtTo}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, createdAtTo: e });
                    updateFilter("createdAtTo", e);
                  }}
                  views={["year", "month", "date"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          {/* Role */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Role</InputLabel>
                <Select
                  label="Role"
                  value={userFilters.role}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, role: e.target.value });
                    updateFilter("role", e.target.value);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  {ROLE_OPTIONS.map((r) => (
                    <MenuItem key={r} value={r}>{r}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Category */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  label="Category"
                  value={userFilters.category}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, category: e.target.value });
                    updateFilter("category", e.target.value);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  {CATEGORY_OPTIONS.map((c) => (
                    <MenuItem key={c} value={c}>{c}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Sign Up Type */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Sign Up Type</InputLabel>
                <Select
                  label="Sign Up Type"
                  value={userFilters.signUpType}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, signUpType: e.target.value });
                    updateFilter("signUpType", e.target.value);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  {SIGNUP_TYPE_OPTIONS.map((s) => (
                    <MenuItem key={s} value={s}>{s}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Is Blocked */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Blocked</InputLabel>
                <Select
                  label="Blocked"
                  value={userFilters.isBlocked}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, isBlocked: e.target.value });
                    const val = e.target.value === "" ? null : e.target.value === "true";
                    updateFilter("isBlocked", val);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Is Email Verified */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Email Verified</InputLabel>
                <Select
                  label="Email Verified"
                  value={userFilters.isEmailVerified}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, isEmailVerified: e.target.value });
                    const val = e.target.value === "" ? null : e.target.value === "true";
                    updateFilter("isEmailVerified", val);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Profile Completed */}
          <Grid container style={{ padding: "4px 8px" }}>
            <Grid item style={{ width: "100%" }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Profile Completed</InputLabel>
                <Select
                  label="Profile Completed"
                  value={userFilters.isProfileCompleted}
                  onChange={(e) => {
                    setUserFilters({ ...userFilters, isProfileCompleted: e.target.value });
                    const val = e.target.value === "" ? null : e.target.value === "true";
                    updateFilter("isProfileCompleted", val);
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container style={{ paddingTop: 8 }}>
            <Grid item style={{ width: "50%" }}>
              <Button onClick={resetFilter} variant="contained" className={classes.buttonReset}>
                Reset
              </Button>
            </Grid>
            <Grid item style={{ width: "50%" }}>
              <Button variant="contained" onClick={filterUsers} className={classes.buttonApply} color="primary">
                Apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </div>
  );
}
